<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-muted mb-0 hover-cursor">&nbsp;Insurance /&nbsp;</p>
            <p class="text-muted mb-0 hover-cursor">&nbsp;Vendors /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Registration</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row" style="display: flex; justify-content : center; alig-items: center;">
            <div class="col-12 mt-3" style="max-width : 75%">
                <img class="text-center" src="~@/assets/images/register-vendor-header.png" width="100%" />
            </div>
        </div>
        <div>
            <div class="row" style="display: flex; justify-content : center; align-items: center;">
                <div class="col-12 mt-3" style="max-width : 70%">
                    <table style="border-spacing: 0 10px; border-collapse : separate;">
                        <tr>
                            <td width="12%">Nama Vendor</td>
                            <td width="3%">&emsp;:&emsp;</td>
                            <td colspan="2" width="60%">
                                <input 
                                  v-if="!$v.insuranceVendorName.$error"
                                  type="text" 
                                  class="form-control"
                                  id="inputNamaVendor" 
                                  placeholder="Nama Vendor"
                                  v-model.trim="$v.insuranceVendorName.$model"
                                />
                                 <input 
                                  v-else
                                  type="text" 
                                  class="form-control border-red"
                                  id="inputNamaVendor" 
                                  placeholder="Nama Vendor"
                                  v-model.trim="$v.insuranceVendorName.$model"
                                />
                                <div style="color : red; font-size : 12px;" v-if="$v.insuranceVendorName.$error && !$v.insuranceVendorName.required">Insurance vendor name must be filled.</div>
                            </td>
                        </tr>
                        <tr>
                            <td width="12%">Default Rate</td>
                            <td width="3%">&emsp;:&emsp;</td>
                            <td width="55%">
                                <input 
                                    v-if="!$v.insuranceDefaultRate.$error"
                                    type="number" 
                                    class="form-control"
                                    id="inputDefaultRate" 
                                    placeholder="Contoh : 1.8"
                                    v-model.trim="$v.insuranceDefaultRate.$model"
                                />
                                <input 
                                    v-else
                                    type="number" 
                                    class="form-control border-red"
                                    id="inputDefaultRate" 
                                    placeholder="Contoh : 1.8"
                                    v-model.trim="$v.insuranceDefaultRate.$model"
                                />
                                <div style="color : red; font-size : 12px;" v-if="$v.insuranceDefaultRate.$error && !$v.insuranceDefaultRate.required">Insurance default rate must be filled.</div>
                            </td>
                            <td>
                                <span>&emsp;%</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content : center; alig-items: center;">
                <div class="card col-12 mt-3" style="max-width : 70%">
                    <div class="card-body">
                        <span style="line-height : 20px; font-size : 20px; font-weight : 600;">Masa Polis Utama</span>
                        <table style="border-spacing: 0 10px; border-collapse : separate;">
                        <tr>
                            <td width="12%">Start Date</td>
                            <td width="3%">&emsp;:&emsp;</td>
                            <td width="60%">
                                <input
                                  v-if="!$v.insuranceStartDate.$error"
                                  type="date"
                                  class="form-control"
                                  name="insurance_start"
                                  placeholder="Pilih Tanggal"
                                  v-model="$v.insuranceStartDate.$model"
                                />
                                <input
                                  v-else
                                  type="date"
                                  class="form-control border-red"
                                  name="insurance_start"
                                  placeholder="Pilih Tanggal"
                                  v-model="$v.insuranceStartDate.$model"
                                />
                                <div style="color : red; font-size : 12px;" v-if="$v.insuranceStartDate.$error && !$v.insuranceStartDate.required">Insurance start date must be filled.</div>
                            </td>
                        </tr>
                        <tr>
                            <td width="12%">End Date</td>
                            <td width="3%">&emsp;:&emsp;</td>
                            <td width="60%">
                                <input
                                  v-if="!$v.insuranceEndDate.$error"
                                  type="date"
                                  class="form-control"
                                  name="insurance_end"
                                  placeholder="Pilih tanggal"
                                  v-model="$v.insuranceEndDate.$model"
                                />
                                <input
                                  v-else
                                  type="date"
                                  class="form-control border-red"
                                  name="insurance_end"
                                  placeholder="Pilih tanggal"
                                  v-model="$v.insuranceEndDate.$model"
                                />
                                <!-- <input
                                  type="date"
                                  class="form-control w-100"
                                  name="deliver_schedule"
                                  v-model="insuranceEndDate"
                                /> -->

                                <div style="color : red; font-size : 12px;" v-if="$v.insuranceEndDate.$error && !$v.insuranceEndDate.required">Insurance end date must be filled.</div>
                            </td>
                        </tr>
                    </table>
                    </div>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content : center; alig-items: center;">
              <div class="col-12 mt-3" style="max-width : 70%">
                <div class="d-flex flex-row">
                  <div class="pt-4 pr-2">
                    <input type="checkbox" @change="() => integrateInsuranceApi = !integrateInsuranceApi" :checked="integrateInsuranceApi">
                  </div>
                  <div class="p-2">
                    <div style="font-weight : 700; font-size : 18px; margin-bottom : 5px;">Integrasi API</div>
                    <div>Vendor ini menyediakan integrasi API untuk deklarasi asuransi.</div>
                  </div>
                </div>               
              </div>
            </div>
        </div>
        <div class="row" style="display: flex; justify-content : center; alig-items: center;">
            <div class="col-12 mt-3" style="max-width : 70%; padding-right : 0px;">
                <div style="float : right;">
                    <button class="btn btn-danger" @click="toVendorPage">Batal</button>
                    <button class="btn btn-primary ml-1" @click="validateInput">Simpan</button>
                </div>
            </div>
        </div>
       
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { required } from 'vuelidate/lib/validators'
import SideBar from "../SideBar";
import { Money } from "v-money";
import Swal from 'sweetalert2';
export default {
  name: "insuranceVendorRegisterPage",
  components: {
    SideBar,
    Multiselect,
    Money,
  },
  data() {
    return {
      isEditInsurance : false,
      insuranceStartDate : '',
      insuranceEndDate : '',
      insuranceVendorName : '',
      insuranceDefaultRate : null,
      integrateInsuranceApi : false,
      admin: "",
      permission: [],
      loadingButtonSave: false,
      insuranceEdit: [{
        orderCode: "",
        productTitle: "",
        productCode: "",
        newOrderCode: "",
        year: 0,
        prorate: 0,
        sumInsured: 0,
        periodFrom: "",
        periodTo: ""
      }, ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      rateEdit: false,
      prorateEdit: false,
      selectInsurance: [],
      isSelectAll: false,
      polisList: [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      cancelInsurancePermission: false,
      canRedeclare : false,
    };
  },
  validations: {
    insuranceStartDate : {
      required,
    },
    insuranceEndDate : {
      required,
    },
    insuranceVendorName : {
      required,
    },
    insuranceDefaultRate : {
      required,
    },
  },
  methods: {
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if(['22','22.1', '22.2', '22.3'].includes(this.permission[i])) {
          this.viewNewInsurance = true
        }
        if(this.permission[i] == '22.1') {
          this.viewNewInsuranceVendor = true
        }
        if(this.permission[i] == '22.2') {
          this.viewNewInsurancePendingDeclare = true
        }
        if(this.permission[i] == '22.3') {
          this.viewNewInsuranceBatch = true
        }

        if (this.viewNewInsuranceVendor == false) {
          this.$router.push('/')
        }
      }
    },
    getData() {
      this.isEditInsurance = this.$route.query.edit;
      this.vendorId = this.$route.query.vendorId;

      if(this.isEditInsurance && this.vendorId) {
        this.$http
        .get(
          `${process.env.GET_VENDOR_DETAILS}/${this.vendorId}/details`, {
            timeout : 300 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if(response.status == 200) {
             this.insuranceStartDate = this.dateFormat(response.data.data.polisStartDate);
             this.insuranceEndDate = this.dateFormat(response.data.data.polisEndDate);
             this.insuranceVendorName = response.data.data.partnerName;
             this.insuranceDefaultRate = response.data.data.rate;
             this.integrateInsuranceApi = response.data.data.apiIntegrated;
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
      }
    },
    saveChanges() {
      const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary ml-2",
            cancelButton: "btn btn-danger"
          },
          buttonsStyling: false
          });
      swalWithBootstrapButtons.fire({
        title: "<span style='font-size : 24px'>Apakah anda yakin akan menyimpan vendor ini ?</span>",
        text: "",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `
          Ya, saya yakin!
        `,
        cancelButtonText: `
          Batalkan
        `,
      }).then((value) => {
        if (value.isConfirmed) {
          if(this.isEditInsurance) {
            this.editVendor()
          } else {
            this.registerVendor()
          }
        } 
      });
    },
    validateInput() {
      // untuk validasi input dari user
      this.$v.$touch()
      if(!this.$v.$invalid){
        this.saveChanges()
      }
    },
    registerVendor() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      this.$http
        .post(
          `${process.env.ADD_VENDOR}`, {
            partnerName: this.insuranceVendorName,
            rate : parseFloat(this.insuranceDefaultRate),
            polisStartDate: this.insuranceStartDate,
            polisEndDate: this.insuranceEndDate,
            apiIntergrated : this.integrateInsuranceApi
          }, {
            timeout : 300 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if(response.status == 200 && response.data.status == 200) {
            swalWithBootstrapButtons.fire({
              icon: "success",
              title: "Success",
              text: "Vendor telah tersimpan",
            }).then((result) => {
              if(result.isConfirmed) {
                this.$router.push({
                  path: "/insurance/vendors",
                  query: {
                    vendorName: '',
                    page: 1,
                    itemPerPage: 10,
                  },
                });
              } 
            });
          } else {
             swalWithBootstrapButtons.fire({
              icon: "error",
              title: "Failed",
              text: response.data.message,
            }).then((result) => {
              if(result.isConfirmed) {
                this.$router.push({
                  path: "/insurance/vendors",
                  query: {
                    vendorName: '',
                    page: 1,
                    itemPerPage: 10,
                  },
                });
              } 
            });
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
              icon: "error",
              title: "Failed",
              text: error,
            }).then((result) => {
              if(result.isConfirmed) {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                } else {
                  this.$router.push({
                    path: "/insurance/vendors",
                    query: {
                      vendorName: '',
                      page: 1,
                      itemPerPage: 10,
                    },
                  });
                }
              } 
            });
        });
        
    },
    editVendor() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      this.$http
        .post(
          `${process.env.EDIT_VENDOR}/${this.vendorId}/patch`, {
            partnerName: this.insuranceVendorName,
            rate : parseFloat(this.insuranceDefaultRate),
            polisStartDate: this.dateFormat(this.insuranceStartDate),
            polisEndDate: this.dateFormat(this.insuranceEndDate),
            apiIntergrated : this.integrateInsuranceApi
          }, {
            timeout : 300 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if(response.status == 200 && response.data.status == 200) {
            swalWithBootstrapButtons.fire({
              icon: "success",
              title: "Success",
              text: "Data vendor berhasil diubah",
            }).then((result) => {
              if(result.isConfirmed) {
                this.$router.push({
                  path: "/insurance/vendors",
                  query: {
                    vendorName: '',
                    page: 1,
                    itemPerPage: 10,
                  },
                });
              } 
            });
          } else {
             swalWithBootstrapButtons.fire({
              icon: "error",
              title: "Failed",
              text: response.data.message,
            }).then((result) => {
              if(result.isConfirmed) {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                } else {
                  this.$router.push({
                    path: "/insurance/vendors",
                    query: {
                      vendorName: '',
                      page: 1,
                      itemPerPage: 10,
                    },
                  });
                }
              } 
            });
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
              icon: "error",
              title: "Failed",
              text: error,
            }).then((result) => {
              if(result.isConfirmed) {
                this.$router.push({
                  path: "/insurance/vendors",
                  query: {
                    vendorName: '',
                    page: 1,
                    itemPerPage: 10,
                  },
                });
              } 
            });
        });

    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },    
    toPage(e) {
      this.$router.push(e);
    },
    toVendorPage() {
      this.$router.push({
        path: '/insurance/vendors',
        query: {
          vendorName: '',
          page: 1,
          itemPerPage: 10
        }
      })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    dateFormat(date) {
      const d = date.split('/')
      if(d.length > 1) {
        return d[d.length-1] + '-' + d[1] + '-' + d[0]
      } else {
        return d[0]
      }
      
    },
  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.cancelInsurancePermission = allPermission && allPermission.indexOf('15.2') >= 0
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.getData();
    this.cekLogin();
    this.cekPermission();
  },
  watch: {
  },
  // computed: {
  //   reversedMessage: function () {
  //     localStorage.setItem('selectInsurance', this.selectInsurance)
  //     return ''
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.form-control {
  color : rgba(46, 54, 70, 1);
}

.form-control ::placeholder {
  color : rgba(46, 54, 70, 0.8);
}
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/VendorRegistrationPage.vue